import { render, staticRenderFns } from "./AdvantageCard.vue?vue&type=template&id=229932c9&scoped=true"
import script from "./AdvantageCard.vue?vue&type=script&lang=js"
export * from "./AdvantageCard.vue?vue&type=script&lang=js"
import style0 from "./AdvantageCard.vue?vue&type=style&index=0&id=229932c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229932c9",
  null
  
)

export default component.exports